/**
 * Path helpers for the Compose module (compositions list and detail).
 */
import { webApi } from '@mi-front/api-clients';

export interface CompositionViewNavigationState {
  composition?: webApi.EnrichedCompositionListItemDto;
}

export const composeRouteGenerator = {
  listForStationSlug: (slug: string) => `/compose/s/${slug}`,
  createForStationSlug: (slug: string) => `/compose/s/${slug}/create`,
  view: (compositionId: string) => `/compose/${compositionId}`,
  edit: (compositionId: string) => `/compose/${compositionId}/edit`,
  edits: (compositionId: string) => `/compose/${compositionId}/edits`,
  publish: (compositionId: string) => `/compose/${compositionId}/publish`,
  /**
   * Social upload wizard for a platform; optional `editId` preselects a video-editor edit.
   * When `platformId` is omitted, the page resolves the last-used platform for the station.
   */
  upload: (compositionId: string, platformId?: string, editId?: string) => {
    const base = platformId
      ? `/compose/${compositionId}/upload/${platformId.toLowerCase()}`
      : `/compose/${compositionId}/upload`;
    return editId ? `${base}?editId=${encodeURIComponent(editId)}` : base;
  },
};
